import React from 'react'

import { WithTranslation, withTranslation } from 'react-i18next'

import { clsx } from 'clsx'

import ErrorImage from 'shared/images/error-baggage.webp'
import { onCloseApp } from 'shared/lib/closeApp'
import { openWhatsappWithMessage } from 'shared/lib/openWhatsappWithMessage'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { ImageOptimized } from 'shared/ui/image-optimized'

import s from './styles.module.scss'

interface Props extends Partial<WithTranslation> {
  children: React.ReactNode
  path: string
}

type State = {
  errorText: string
  crashData: string
  isOpenDetail: boolean
}

class ErrorHoc extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      errorText: '',
      crashData: '',
      isOpenDetail: false,
    }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({
      errorText: error.message,
      crashData: errorInfo.componentStack || '',
    })
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.path !== this.props.path) {
      this.setState({
        errorText: '',
        crashData: '',
        isOpenDetail: false,
      })
    }
  }

  toggleIsOpenDetail = () => {
    this.setState((prev) => ({
      ...prev,
      isOpenDetail: !this.state.isOpenDetail,
    }))
  }

  onReload = () => {
    window.location.reload()
  }

  onGoHome = () => {
    window.location.href = '/'
  }

  onWriteWhatsapp = () => {
    openWhatsappWithMessage('')
  }

  closeApp = () => {
    onCloseApp()
  }

  render() {
    const { errorText } = this.state

    if (errorText) {
      return (
        <div className={s.wrapper}>
          <div className={s.header}>
            <button className={s.crossButton}>
              <AppIcon
                id={AllIcons.CROSS}
                onClick={this.closeApp}
                width={24}
                height={24}
              />
            </button>
          </div>

          <div className={s.content}>
            <div className={s.imageWrapper}>
              <ImageOptimized
                src={ErrorImage}
                alt="error"
              />
            </div>

            <div className={s.body}>
              <p className={clsx('bold-18', s.title)}>
                {this.props.t && this.props.t('hoc_error')}
              </p>
              <p className={clsx('medium-14', s.description)}>
                {this.props.t && this.props.t('hoc_error_des')}
              </p>
            </div>

            <div className={s.actions}>
              <Button
                variant="white"
                className={clsx('semi-bold-17', s.button)}
                onClick={this.onWriteWhatsapp}
              >
                {this.props.t && this.props.t('write_whatsapp')}
              </Button>
              <Button
                className={clsx('semi-bold-17', s.button)}
                onClick={this.onGoHome}
              >
                {this.props.t && this.props.t('go_to_home')}
              </Button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default withTranslation()(ErrorHoc)
